<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [showLinkIcon]="isUpdatingIssue"
      [linkIcon]="'share'"
      (linkAction)="shareTask()"
      [title]="isUpdatingIssue ? 'Maintenance' : 'Add Maintenance'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
      <div style="display: flex; flex-wrap: wrap; gap: 20px; margin-bottom: 15px;">
        <!-- Members Section -->
        <div>
          <tidy-text [smallBody]="'Members'" style="display: block; margin-bottom: 5px;" />
          <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 5px;">
            @for (user of issue?.checkedUsers; track user) {
              @if (user?.name == 'Concierge') {
                <div style="display: inline-flex; align-items: center;">
                  <tidy-image [src]="'assets/img/concierge.svg'" style="width: 26px" />
                </div>
              }
              @if (user?.name !== 'Concierge') {
                <div>
                  <tidy-initials-icon [fullName]="user?.name" />
                </div>
              }
            }
            <div class="add-chip-button circle" mat-icon-button [matMenuTriggerFor]="personMenu" (click)="$event.stopPropagation()">
              <ion-icon name="add" />
            </div>
          </div>
        </div>
        <!-- Jobs Section -->
        <div>
          <tidy-text [smallBody]="'Jobs'" style="display: block; margin-bottom: 5px;" />
          <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 8px;">
            @for (job of issue?.checkedJobs; track job) {
              <ion-chip class="filter-chip">
                <tidy-image
                  [src]="job?.icon_url"
                  style="width: 14px; margin-right: 4px;" />
                @if (job?.status?.icon_type == 'image') {
                  <tidy-image
                    [src]="job?.status?.icon"
                    [ngClass]="issue?.checkedJobs[0]?.status?.class ? issue?.checkedJobs[0]?.status?.class : ''" />
                }
                @if (job?.status?.icon_type == 'initials') {
                  <div
                    [ngClass]="job?.status?.class"
                    [style.background]="util.getAvatarGradient(job?.status?.initials || 'BA')">
                    {{job?.status?.initials | uppercase}}
                  </div>
                }
                <ion-label>{{ job?.name }}</ion-label>
              </ion-chip>
            }
            <div class="add-chip-button" mat-icon-button [matMenuTriggerFor]="jobMenu" (click)="$event.stopPropagation(); onJobMenuClicked()">
              <ion-icon name="add" />
            </div>
          </div>
        </div>
        <!-- Assets Section -->
        <div>
          <tidy-text [smallBody]="'Assets'" style="display: block; margin-bottom: 5px;" />
          <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 8px;">
            @for (item of issue?.checkedItems; track item) {
              <ion-chip class="filter-chip">
                @if (item?.model?.category?.default_icon_url) {
                  <tidy-image
                    [src]="item?.model?.category?.default_icon_url"
                    style="width: 14px; margin-right: 4px;" />
                }
                <ion-label>{{ item?.name }}</ion-label>
              </ion-chip>
            }
            <div #itemMenuTrigger class="add-chip-button" mat-icon-button [matMenuTriggerFor]="itemMenu" (click)="$event.stopPropagation(); onItemMenuClicked()">
              <ion-icon name="add" />
            </div>
          </div>
        </div>
      </div>
      @if (issue?.concierge_items?.length) {
        <tidy-alert>
          <tidy-row class="vertical-align-center">
            <tidy-image
              src="assets/img/concierge.svg"
              class="title-size" />
            <tidy-text
              [header]="'Concierge Action Plan'" />
          </tidy-row>
          @for (item of issue?.concierge_items; track item; let last = $last) {
            <tidy-card-button (action)="goToConciergeMessage(item)" [class.no-below-stroke]="last">
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [body]="item?.metadata?.request_data?.subject" />
              </tidy-row>
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [helper]="item?.metadata?.request_data?.body" />
              </tidy-row>
              <tidy-row class="vertical-align-center no-padding">
                @if (item?.metadata?.request_data?.scheduled == 'Immediate' || item?.metadata?.request_data?.scheduled == 'immediate') {
                  <tidy-text
                    [helper]="'Scheduled to do immediately'" />
                }
                @if (item?.metadata?.request_data?.scheduled !== 'Immediate' && item?.metadata?.request_data?.scheduled !== 'immediate') {
                  <tidy-text
                    [helper]="'Scheduled to do on'" /><span>&nbsp;</span>
                    <tidy-text
                      [helper]="item?.metadata?.request_data?.scheduled | parseDateTime: 'MMM d'" />
                  }
                </tidy-row>
              </tidy-card-button>
            }
          </tidy-alert>
        }
        <tidy-card style="margin-top: 5px">
          <form [formGroup]="issueForm" novalidate action="#">
            <tidy-row>
              <tidy-textarea
                label="Title"
                [icon]="'assets/svg/checkbox.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a title'"
                class="title-input"
                [form]="issueForm.get('title')"
                formControlName="title" />
            </tidy-row>
            <div style="display: flex; gap: 10px; margin-bottom: 5px; flex-wrap: wrap;">
              <div style="flex: 2; min-width: 200px;">
                <tidy-select
                  label="Property"
                  [icon]="'assets/svg/home.svg'"
                  [items]="propertyOptions"
                  [submitted]="submitted"
                  [form]="issueForm.get('address_id')"
                  formControlName="address_id"
                  (optionChange)="getDataForAddress()"
                  style="width: 100%;" />
              </div>
              <div style="flex: 1; min-width: 200px;">
                <tidy-datepicker
                  label="Due Date"
                  [icon]="'assets/svg/calendar.svg'"
                  formControlName="due_date"
                  [form]="issueForm.controls.due_date"
                  style="width: 100%;" />
              </div>
            </div>
            <div style="display: flex; gap: 10px; margin-bottom: 5px; flex-wrap: wrap;">
              <div style="position: relative; flex: 1; min-width: 120px;">
                <tidy-select
                  label="Status"
                  [icon]="'assets/svg/flag.svg'"
                  [items]="statusOptions"
                  [submitted]="submitted"
                  [form]="issueForm.get('status')"
                  formControlName="status"
                  style="width: 100%;" />
              </div>
              <div style="flex: 1; min-width: 120px;">
                <tidy-select
                  label="Type"
                  [icon]="'assets/svg/list.svg'"
                  [items]="issueTypeOptions"
                  [submitted]="submitted"
                  [form]="issueForm.get('issue_report_type_id')"
                  formControlName="issue_report_type_id"
                  style="width: 100%;" />
              </div>
              <div style="position: relative; flex: 1; min-width: 120px;">
                <tidy-select
                  label="Urgency"
                  [icon]="'assets/svg/alert-circle.svg'"
                  [items]="urgencyOptions"
                  [submitted]="submitted"
                  [form]="issueForm.get('urgency')"
                  formControlName="urgency"
                  style="width: 100%;" />
              </div>
            </div>
            <tidy-row class="no-padding">
              <tidy-textarea
                label="Description"
                [icon]="'assets/svg/create.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a description'"
                [form]="issueForm.get('description')"
                formControlName="description" />
            </tidy-row>
          </form>
          <mat-menu #personMenu="matMenu" class="filter-menu">
            @for (user of issue?.allUsers; track user) {
              <button mat-menu-item class="tree-node-padding">
                <mat-checkbox
                  class="checkbox"
                  [checked]="user?.checked"
                  (click)="$event.stopPropagation()"
                  (change)="checkOrUncheckPerson(issue, user, $event)">
                  {{user?.name}}
                </mat-checkbox>
              </button>
            }
          </mat-menu>
          <mat-menu #jobMenu="matMenu" style="max-width: 600px !important;">
            <div style="padding: 10px; border-bottom: 1px solid #e0e0e0;" (click)="$event.stopPropagation()">
              <form [formGroup]="jobSearchForm" novalidate action="#">
                <tidy-search-input
                  #jobSearchInput
                  formControlName="search"
                  [placeholder]="'Search jobs'"
                  [icon]="'assets/svg/search.svg'"
                  (click)="$event.stopPropagation()"
                  (focus)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()" />
              </form>
            </div>
            @for (job of filteredJobs; track job) {
              <button mat-menu-item class="tree-node-padding" style="display: flex; align-items: center; justify-content: space-between; width: 100%">
                <mat-checkbox
                  class="checkbox"
                  (click)="$event.stopPropagation()"
                  [checked]="job?.checked"
                  (change)="checkOrUncheckJob(job, $event)">
                  <tidy-text
                    [body]="job?.name" /><span>&nbsp;</span>
                    <tidy-text
                      [helper]="'-'" /><span>&nbsp;</span>
                      <tidy-text
                        [helper]="job?.service_name"
                        style="margin-right: 5px" />
                    </mat-checkbox>
                    <tidy-image
                      [src]="'assets/img/chevron-right.svg'"
                      class="right-item chevron-icon no-right-margin"
                      (action)="goToJob(job, $event)" />
                  </button>
                }
                @if (jobsLoaded && filteredJobs && !filteredJobs?.length && issue?.allJobs?.length) {
                  <div style="margin: 10px;">
                    <tidy-text [helper]="'<i>No results</i>'" />
                  </div>
                }
                @if (jobsLoaded && issue?.allJobs && !issue?.allJobs?.length) {
                  <div style="margin: 10px;">
                    <tidy-text [helper]="'<i>No jobs booked</i>'">></tidy-text>
                  </div>
                }
                @if (!jobsLoaded) {
                  <div style="margin: 10px;">
                    <tidy-text [helper]="'Loading jobs...'">></tidy-text>
                  </div>
                }
                <mat-divider />
                <tidy-row class="vertical-align-center extra-top-padding extra-bottom-padding" style="margin-left: 7px; margin-right: 10px">
                  <tidy-image
                    [src]="'assets/svg/add-circle.svg'"
                    class="header-size white-icon" />
                  <tidy-text
                    [actionBody]="'Add Job'"
                    (action)="goToAddJob()" />
                </tidy-row>
              </mat-menu>
              <mat-menu #itemMenu="matMenu" style="max-width: 600px !important;">
                <div style="padding: 10px; border-bottom: 1px solid #e0e0e0;" (click)="$event.stopPropagation()">
                  <form [formGroup]="itemSearchForm" novalidate action="#">
                    <tidy-search-input
                      #itemSearchInput
                      formControlName="search"
                      [placeholder]="'Search assets'"
                      [icon]="'assets/svg/search.svg'"
                      (click)="$event.stopPropagation()"
                      (focus)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()" />
                  </form>
                </div>
                @for (item of filteredItems; track item) {
                  <button mat-menu-item class="tree-node-padding" style="display: flex; align-items: center; justify-content: space-between; width: 100%">
                    <mat-checkbox
                      class="checkbox"
                      (click)="$event.stopPropagation()"
                      [checked]="item?.checked"
                      (change)="checkOrUncheckItem(item, $event)">
                      <tidy-text
                        [body]="item?.name" />
                    </mat-checkbox>
                    <tidy-image
                      [src]="'assets/img/chevron-right.svg'"
                      class="right-item chevron-icon no-right-margin"
                      (action)="goToItem(item, $event)" />
                  </button>
                }
                @if (filteredItems && !filteredItems?.length && allItems?.length) {
                  <div style="margin: 10px;">
                    <tidy-text [helper]="'<i>No results</i>'" />
                  </div>
                }
                @if (filteredItems && allItems && !allItems?.length) {
                  <div style="margin: 10px;">
                    <tidy-text [helper]="'<i>No assets added</i>'" />
                  </div>
                }
                @if (!filteredItems?.length) {
                  <div style="margin: 10px;">
                    <tidy-text [helper]="'<i>Loading assets...</i>'" />
                  </div>
                }
                <mat-divider />
                <tidy-row class="vertical-align-center extra-top-padding extra-bottom-padding" style="margin-left: 7px; margin-right: 10px">
                  <tidy-image
                    [src]="'assets/svg/add-circle.svg'"
                    class="header-size white-icon" />
                  <tidy-text
                    [actionBody]="'Add Asset'"
                    (action)="goToAddItem()" />
                </tidy-row>
              </mat-menu>
              @if (!reportPhotos || reportPhotos?.length === 0) {
                <tidy-row [align]="'center'">
                  <tidy-text
                    body="Add Photo"
                    class="link"
                    (click)="$event.stopPropagation()"
                    (action)="addAttachment(issue)" />
                </tidy-row>
              }
              @if (reportPhotos?.length > 0) {
                <tidy-row [alignLastItemRight]="true">
                  <tidy-text
                    header="Photos"
                    style="margin-right: 5px" />
                  <tidy-text
                    body="Add Photo"
                    class="link"
                    (click)="$event.stopPropagation()"
                    (action)="addAttachment(issue)" />
                </tidy-row>
              }
              @for (attachment of reportPhotos; track attachment; let i = $index) {
                <ng-container class="field-top-padding">
                  <tidy-row>
                    <tidy-image
                      [src]="attachment.photo_url.includes('http') ? attachment.photo_url : attachment.full_photo_url"
                      style="width: 100%" />
                  </tidy-row>
                  <tidy-row [align]="'center'" class="extra-bottom-padding">
                    <tidy-text
                      [actionBody]="'remove'"
                      (action)="removeAttachment(i, attachment)"
                      class="link red" />
                  </tidy-row>
                </ng-container>
              }
            </tidy-card>
            @if (isUpdatingIssue) {
              @if (customFields.length > 0) {
                <tidy-card>
                  <tidy-row class="extra-bottom-padding" [alignLastItemRight]="true">
                    <tidy-text [header]="'Custom Fields'" />
                    <tidy-text
                      [actionBody]="'Edit'"
                      (action)="editCustomFields()"
                      class="link" />
                  </tidy-row>
                  @for (item of customFields; track item) {
                    <tidy-row>
                      <tidy-text [body]="item?.name + ': ' + item?.value || 'N/A'" />
                    </tidy-row>
                  }
                </tidy-card>
              }
              @if (customFields.length === 0) {
                <tidy-card>
                  <tidy-row class="extra-bottom-padding">
                    <tidy-text [header]="'Custom Fields'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text [body]="'No custom fields added.'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [actionBody]="'Create Custom Field'"
                      (action)="addCustomField()"
                      class="link" />
                  </tidy-row>
                </tidy-card>
              }
            }
            @if (!isUpdatingIssue) {
              <tidy-button
                [action]="boundSaveIssue"
                class="primary save-issue-button"
                [text]="'Save'" />
            }
            @if (errorMessage) {
              <tidy-error-message
                [text]="errorMessage" />
            }
            @if (isUpdatingIssue) {
              <tidy-row class="extra-bottom-padding" [align]="'center'">
                <tidy-text
                  [helper]="'Reported by'" /><span>&nbsp;</span>
                  <tidy-text
                    [helper]="issue.reporter_name" /><span>&nbsp;</span>
                    <tidy-text
                      [helper]="'at'" /><span>&nbsp;</span>
                      <tidy-text
                        [helper]="issue.created_at | parseDateTime:'h:mma':'local'" /><span>&nbsp;</span>
                        <tidy-text
                          [helper]="'on'" /><span>&nbsp;</span>
                          <tidy-text
                            [helper]="issue.created_at | parseDateTime:'MMM d':'local'" />
                        </tidy-row>
                      }
                      <tidy-row [align]="'center'">
                        @if (isUpdatingIssue && !issue?.archived_at) {
                          <tidy-text
                            [body]="'Archive Maintenance Task'"
                            class="link red"
                            (action)="archiveTask()" />
                        }
                        @if (isUpdatingIssue && issue?.archived_at) {
                          <tidy-text
                            [body]="'Unarchive Maintenance Task'"
                            class="link green"
                            (action)="unarchiveTask()" />
                        }
                      </tidy-row>
                      @if (isUpdatingIssue && issue?.archived_at) {
                        <tidy-row [align]="'center'">
                          <tidy-text
                            [body]="'Delete Maintenance Task'"
                            class="link red"
                            (action)="deleteTask()" />
                        </tidy-row>
                      }
                      @if (issue?.id) {
                        <tidy-row>
                          <tidy-text
                            header="Activity" />
                        </tidy-row>
                        <form [formGroup]="messageForm">
                          <tidy-row>
                            <tidy-textarea
                              class="select-custom-input"
                              [label]="'Write a Note'"
                              [icon]="'assets/svg/document-text.svg'"
                              formControlName="message"
                              [form]="messageForm.controls.message"
                              [submitted]="messageSubmitted"
                              [errorMessage]="'Please enter a message to send.'"
                              [rightIconAction]="boundSendMessage" />
                          </tidy-row>
                        </form>
                        @if (!activities?.length) {
                          <tidy-alert>
                            <tidy-text
                              [helper]="'No Activity'" />
                          </tidy-alert>
                        }
                        @for (activity of activities; track activity) {
                          <div style="margin-bottom: 10px">
                            @if (activity?.activity_type === 'comment') {
                              <div class="activity-header">
                                <div class="flex-content">
                                  <div style="margin-right: 5px; margin-top: 2px">
                                    <tidy-initials-icon class="activity-initials" [fullName]="activity?.userName" />
                                  </div>
                                  <div style="margin-right: 5px">
                                    <tidy-text [header]="activity?.userName" />
                                  </div>
                                  <div>
                                    <tidy-text
                                      [matTooltip]="!activity?.pastMoreThanOneDay ? (activity?.createdAt | translate) : (null | translate)"
                                      [helper]="!activity?.pastMoreThanOneDay ? activity?.textDate : activity?.createdAt"
                                    class="small-text" />
                                  </div>
                                </div>
                              </div>
                              <div style="margin-left: 35px">
                                <tidy-alert style="margin-top: 5px; margin-bottom: 5px">
                                  <tidy-text [body]="activity?.description" />
                                </tidy-alert>
                                @if (activity?.by_user?.id == issue?.reporter_id) {
                                  <tidy-text
                                    [body]="'Delete'"
                                    (action)="deleteActivity(activity)"
                                    class="link red" />
                                }
                              </div>
                            }
                            @if (activity?.activity_type !== 'comment') {
                              <div class="activity-header">
                                <div class="flex-content">
                                  <div style="margin-right: 5px; margin-top: 2px">
                                    <tidy-initials-icon class="activity-initials" [fullName]="activity?.userName" />
                                  </div>
                                  <div>
                                    <tidy-text [body]="activity?.description" />
                                  </div>
                                </div>
                              </div>
                              @if (activity?.photo) {
                                <div class="activity-photo">
                                  <img [src]="activity?.photo" (click)="openPhoto(activity?.photo)">
                                </div>
                              }
                              <div style="margin-left: 40px; margin-top: 5px">
                                <tidy-text
                                  [matTooltip]="!activity?.pastMoreThanOneDay ? (activity?.createdAt | translate) : (null | translate)"
                                  [helper]="!activity?.pastMoreThanOneDay ? activity?.textDate : activity?.createdAt"
                                class="small-text" />
                              </div>
                            }
                          </div>
                        }
                      }
                      <div style="height: 100px"></div>
                    }
                  </tidy-wrapper>
                </ng-template>

                @if (!windowService.isDesktopRes) {
                  <app-scroll-wrapper [templateContent]="content" />
                }

                @if (windowService.isDesktopRes) {
                  <ng-container *ngTemplateOutlet="content" />
                }





